var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_3227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.25C10.683 12.25 12.25 10.683 12.25 8.75C12.25 6.817 10.683 5.25 8.75 5.25C6.817 5.25 5.25 6.817 5.25 8.75C5.25 10.683 6.817 12.25 8.75 12.25Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12.25C21.183 12.25 22.75 10.683 22.75 8.75C22.75 6.817 21.183 5.25 19.25 5.25C17.317 5.25 15.75 6.817 15.75 8.75C15.75 10.683 17.317 12.25 19.25 12.25Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.25C10.683 12.25 12.25 10.683 12.25 8.75C12.25 6.817 10.683 5.25 8.75 5.25C6.817 5.25 5.25 6.817 5.25 8.75C5.25 10.683 6.817 12.25 8.75 12.25Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12.25C21.183 12.25 22.75 10.683 22.75 8.75C22.75 6.817 21.183 5.25 19.25 5.25C17.317 5.25 15.75 6.817 15.75 8.75C15.75 10.683 17.317 12.25 19.25 12.25Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.75C10.683 22.75 12.25 21.183 12.25 19.25C12.25 17.317 10.683 15.75 8.75 15.75C6.817 15.75 5.25 17.317 5.25 19.25C5.25 21.183 6.817 22.75 8.75 22.75Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.75V22.75",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 19.25H15.75",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_3227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/products-icon.732826b4.svg";
export { ForwardRef as ReactComponent };